<template>
  <b-col class="nav-302 ">
    <b-row align-h="center" align-v="center" class="py-1 text-center">
      <b-col order="1" cols="4" lg="2" class="text-right">
        <a v-b-toggle.nav-302-items class="text-dark  h2" href="javascript:void(0)">
          <b-icon-list class="my-auto  "/>
        </a>
      </b-col>


      <b-col order="9" order-lg="1" order-sm="9" order-md="9" cols="8" lg="3" class="p-0 m-0 my-sm-2">
        <div class="mx-auto ">
          <m-search-input-5 class="nav300-search text-center d-inline-flex mx-auto"/>
        </div>
      </b-col>

      <b-col order="1" cols="4" lg="3">
        <m-a :href="{name:'Home'}">
          <m-img class="nav-302-logo" :src="findAttributeOnSiteInfo('icon')[0]"
                 :alt="findAttributeOnSiteInfo('site_name')[0]"/>
        </m-a>
      </b-col>


      <b-col class="d-lg-none " order="1" cols="4" lg="3">

      </b-col>

      <hr class="d-lg-none w-100 order-7 "/>


      <b-col order="9" order-lg="1" order-sm="9" order-md="9" cols="4" lg="4">

        <m-a class="text-dark nav-302-icon h3" :href="{name:'Dashboard'}">
          <b-icon-person class="my-auto"/>
        </m-a>

        <!-- shopping cart -->
        <m-a class="text-dark nav-302-icon h3" v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1"
             :href="{ name: 'ShoppingCart' }">
          <b-icon-cart class="my-auto  "/>
          <span class="badge badge-warning shopping-cart-counter "
                v-if=" orderCount.length != 0 && orderCount.items != undefined">{{ orderCount.items.length }} </span>
        </m-a>
        <m-a v-else class="text-dark nav-302-icon h3" :href="{ name: 'UnAuthenticatedShoppingCart' }">
          <b-icon-cart class="my-auto  "/>
        </m-a>
        <!-- shopping cart -->

      </b-col>

      <b-sidebar ref="sidebar" id="nav-302-items" backdrop shadow="">
        <div class="menu-list px-3 py-2 d-flex text-center align-items-center">


          <div class="mx-auto" v-for="menu in storeMenus" :key="menu.id"
               v-if="menu.position === 'store_nav'">
            <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>
          </div>

        </div>
      </b-sidebar>
    </b-row>

  </b-col>
</template>

<script>
import NavMenuItem from './NavMenuItem'
import {mapGetters} from "vuex";


export default {
  name: "Nav302",
  components: {NavMenuItem,},
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      storeMenus: "Menu/getStoreMenus",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
}
</script>

<style>

.nav300-search .custom-padding {
  padding: 20px 8px !important;
  text-align: center !important;
}

.nav300-search .w-50 {
  width: 100% !important;
}

.nav300-search input {
  border-radius: 0.625rem !important;
  background-color: rgb(235, 237, 240);
}

.nav300-search input::placeholder {
  text-align: center;
}

</style>

<style scoped>
.nav-302-logo {
  width: 90px;
  height: auto;
  margin-bottom: 5px;
}


.nav-302-icon {
  margin-right: 3px;
}

.shopping-cart-counter {
  font-size: 12px;
  margin: 16px -14px 0 0;
  position: absolute;
}
</style>